import { takeLatest, put, all, call } from 'redux-saga/effects'

import fetchClient from '~/services/fetchClient.js'

import { updateCampaignConfig } from './actions'

export function* getCampaignConfig({ payload }) {
  try {
    const { campaignId } = payload

    if (!campaignId) throw new Error('Ocorreu um erro ao processar a requisição')

    const url = `/campaign/${campaignId}/consumerEntryPoint`

    const response = yield call(fetchClient.get, url)

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(
          updateCampaignConfig({
            campaign: {
              ...response.data.data[0]
            }
          })
        )
      } else {
        yield put(
          updateCampaignConfig({
            campaign: {
              ...response.data?.data?.[0],
              ...(response.data?.campaignLockReasons ? { campaignLockReasons: response.data.campaignLockReasons } : {})
            },
            error: response?.data?.errors?.[0] || response.data?.message
          })
        )
      }
    } else {
      yield put(
        updateCampaignConfig({
          error: 'Ocorreu um erro ao processar a requisição'
        })
      )
    }
  } catch (error) {
    yield put(updateCampaignConfig({ error: error.message }))
  }
}

export default all([takeLatest('campaign/GET_CAMPAIGN_CONFIG', getCampaignConfig)])
